import {
  type DomainAttributesType
} from './Ambiguous'
import { LoadedDomain } from './Loaded'

import { type LoadedPersistedType } from '../../../../Foobara/Autocrud/Types/PersistedType/Loaded'

import { type LoadedDynamicCommand } from '../../../../Foobara/Commandforge/Types/DynamicCommand/Loaded'

export interface DomainAggregateAttributesType extends DomainAttributesType {
  id: number
  persisted_types: LoadedPersistedType[]
  persisted_commands: LoadedDynamicCommand[]
  name?: string
  organization_name?: string | null
  full_name?: string
}

export class DomainAggregate extends LoadedDomain<DomainAggregateAttributesType> {
  /* eslint-disable @typescript-eslint/class-literal-property-style */
  get isAtom (): false { return false }
  get isAggregate (): true { return true }
  /* eslint-enable @typescript-eslint/class-literal-property-style */
}
